import { css } from 'lit';

export default css`.fs-choice-button {
    align-items: center;
    background: var(--fs-form-color-background-default, hsl(0, 0%, 100%));
    border: var(--fs-border-solid-thin, 1px solid) var(--fs-form-color-border-default, hsl(0, 0%, 41%));
    border-radius: var(--fs-radius-small, 4px);
    box-sizing: border-box;
    color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
    cursor: pointer;
    display: flex;
    font-family: var(--fs-font-stack, Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif);
    flex: 1 0 0;
    flex-flow: column;
    gap: var(--fs-size-spacing-tiny3, 4px);
    hyphens: auto;
    min-height: var(--fs-size-large2, 40px);
    overflow-wrap: break-word;
    padding: var(--fs-size-spacing-small1, 8px) var(--fs-size-spacing-medium1, 16px);
    width: 0;
    word-break: break-word;
  }

  .fs-choice-button--compact {
    min-height: var(--fs-size-large1, 32px);
    padding: var(--fs-size-tiny3, 4px) var(--fs-size-small1, 8px)
  }

  .fs-choice-button--compact .fs-choice-button__label {
      font-size: var(--fs-font-size-small1, 0.75rem);
    }

  .fs-choice-button:hover {
    border: var(--fs-border-solid-medium, 2px solid) var(--fs-form-color-border-hover, hsl(200, 98%, 35%));
  }

  .fs-choice-button__control:checked + .fs-choice-button:active .fs-choice-button__label,
  .fs-choice-button:active .fs-choice-button__label {
    color: var(--fs-color-interactive-primary-active, hsl(200, 98%, 23%))
  }

  .fs-choice-button__control:not(:disabled) + .fs-choice-button:active {
    border: var(--fs-border-solid-medium, 2px solid) var(--fs-form-color-border-active, hsl(200, 98%, 23%));
  }

  .fs-choice-button__control:not(:disabled) + .fs-choice-button:not(.fs-choice-button--compact):hover,
  .fs-choice-button__control:not(:disabled) + .fs-choice-button:not(.fs-choice-button--compact):active,
  .fs-choice-button__control:not(:disabled) + .fs-choice-button__control:checked + .fs-choice-button {
    padding: calc(var(--fs-size-spacing-small1, 8px) - 1px) calc(var(--fs-size-spacing-medium1, 16px) - 1px);
  }

  .fs-choice-button.fs-choice-button--compact:hover,
  .fs-choice-button.fs-choice-button--compact:active,
  .fs-choice-button__control:checked + .fs-choice-button.fs-choice-button--compact {
    padding: calc(var(--fs-size-tiny3, 4px) - 1px) calc(var(--fs-size-small1, 8px) - 1px);
  }

  .fs-choice-button__control:checked + .fs-choice-button {
    background: var(--fs-color-background-highlight, hsl(200, 100%, 97%));
    border: var(--fs-border-solid-medium, 2px solid) currentColor;
    color: var(--fs-color-interactive-primary-default, hsl(200, 98%, 35%));
    padding: calc(var(--fs-size-spacing-small1, 8px) - 1px) calc(var(--fs-size-spacing-medium1, 16px) - 1px)
  }

  .fs-choice-button__control:checked + .fs-choice-button .fs-choice-button__label {
      color: var(--fs-color-interactive-primary-default, hsl(200, 98%, 35%));
    }

  .fs-choice-button__control:disabled + .fs-choice-button {
    background: var(--fs-form-color-background-default, hsl(0, 0%, 100%));
    border-color: var(--fs-form-color-border-disabled, hsl(0, 0%, 83%));
    cursor: not-allowed;
  }

  .fs-choice-button__control:disabled + .fs-choice-button,
  .fs-choice-button__control:disabled + .fs-choice-button .fs-choice-button__label,
  .fs-choice-button__control:disabled + .fs-choice-button .fs-choice-button__subtext {
    color: var(--fs-text-color-disabled, hsl(0, 0%, 49%));
  }

  /** TODO: find a better solution for sharing focusi indicator styles */
  .fs-choice-button__control:focus + .fs-choice-button {
    outline: 0;
    box-shadow: 0 0 0 2px var(--fs-color-focus-secondary-default, hsl(0, 0%, 100%)), 0 0 0 4px var(--fs-color-focus-primary-default, hsl(200, 98%, 35%));
  }

  .fs-choice-button__control,
  .fs-choice-button input {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  .fs-choice-button__label {
    color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
    font-size: var(--fs-font-size-small2, 0.875rem);
    font-weight: var(--fs-font-weight-semibold, 600);
    line-height: var(--fs-font-line-height-small, 1.3);
  }

  .fs-choice-button__subtext {
    color: var(--fs-text-color-secondary, hsl(0, 0%, 41%));
    font-size: var(--fs-font-size-small1, 0.75rem);
  }

  .fs-choice-button__label,
  .fs-choice-button__subtext {
    display: block;
  }

  .fs-choice-button--alignment-left {
    align-items: center;
    gap: var(--fs-size-spacing-small1, 8px);
    flex-flow: row;
  }

  .fs-choice-button--alignment-center .fs-choice-button__text {
    text-align: center;
  }

  .fs-choice-button--alignment-left .fs-choice-button__text {
    text-align: left;
  }

  /* Choice button group */
  .fs-choice-button-group {
    display: flex;
    flex-flow: row;
    gap: var(--fs-size-spacing-small1, 8px);
  }

  .fs-choice-button-group:not(.fs-choice-button-group--items-per-row) > * {
    flex: 1 0 0;
  }

  .fs-choice-button-group--column {
    flex-flow: column
  }

  .fs-choice-button-group--column > .fs-choice-button {
      flex: 1 1 auto;
      width: unset;
    }

  .fs-choice-button-group--items-per-row:not(.fs-choice-button-group--column) {
    display: grid;
    grid-template-columns: repeat(var(--fs-choice-buttons-per-row, 1), 1fr);
  }

  .fs-choice-button-group--items-per-row > .fs-choice-button {
    width: unset;
  }`;